import { render, staticRenderFns } from "./ConferenceRoomSchedules.vue?vue&type=template&id=04c04dec&scoped=true"
import script from "./ConferenceRoomSchedules.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c04dec",
  null
  
)

export default component.exports